import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { Observable, of as observableOf, merge } from 'rxjs';

// TODO: Replace this with your own data model type
export interface PendingApprovalItem {
  name: string;
  id: number;
  att_date: string;
  in_image: string;
  in_time: string;
  out_image: string;
  out_time: string;
  updated_at: string;

}

// TODO: replace this with real data from your application
const EXAMPLE_DATA: PendingApprovalItem[] = [
  { id: 1, name: 'Kanika', att_date:'20-06-2020', in_image: '', in_time: '8:00 PM', out_image: '', out_time: '6:30 PM', updated_at: '21-06-2020' },
  { id: 1, name: 'Kanika', att_date:'20-06-2020', in_image: '', in_time: '8:00 PM', out_image: '', out_time: '6:30 PM', updated_at: '21-06-2020' },
  { id: 1, name: 'Kanika', att_date:'20-06-2020', in_image: '', in_time: '8:00 PM', out_image: '', out_time: '6:30 PM', updated_at: '21-06-2020' },
  { id: 1, name: 'Kanika', att_date:'20-06-2020', in_image: '', in_time: '8:00 PM', out_image: '', out_time: '6:30 PM', updated_at: '21-06-2020' },
  { id: 1, name: 'Kanika', att_date:'20-06-2020', in_image: '', in_time: '8:00 PM', out_image: '', out_time: '6:30 PM', updated_at: '21-06-2020' },
  { id: 1, name: 'Kanika', att_date:'20-06-2020', in_image: '', in_time: '8:00 PM', out_image: '', out_time: '6:30 PM', updated_at: '21-06-2020' },
  { id: 1, name: 'Kanika', att_date:'20-06-2020', in_image: '', in_time: '8:00 PM', out_image: '', out_time: '6:30 PM', updated_at: '21-06-2020' },
  
];

/**
 * Data source for the PendingApproval view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class PendingApprovalDataSource extends DataSource<PendingApprovalItem> {
  data: PendingApprovalItem[] = EXAMPLE_DATA;
  paginator: MatPaginator;
  sort: MatSort;

  constructor() {
    super();
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(): Observable<PendingApprovalItem[]> {
    // Combine everything that affects the rendered data into one update
    // stream for the data-table to consume.
    const dataMutations = [
      observableOf(this.data),
      this.paginator.page,
      this.sort.sortChange
    ];

    return merge(...dataMutations).pipe(map(() => {
      return this.getPagedData(this.getSortedData([...this.data]));
    }));
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect() {}

  /**
   * Paginate the data (client-side). If you're using server-side pagination,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getPagedData(data: PendingApprovalItem[]) {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    return data.splice(startIndex, this.paginator.pageSize);
  }

  /**
   * Sort the data (client-side). If you're using server-side sorting,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getSortedData(data: PendingApprovalItem[]) {
    if (!this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      const isAsc = this.sort.direction === 'asc';
      switch (this.sort.active) {
        case 'name': return compare(a.name, b.name, isAsc);
        case 'id': return compare(+a.id, +b.id, isAsc);
        default: return 0;
      }
    });
  }
}

/** Simple sort comparator for example ID/Name columns (for client-side sorting). */
function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
